export default "__VITE_ASSET__CSICHRCu__"